const formatPlace = place => ({
	_id: place._id,
	rut: place.rut,
	name: place.name,
	services: place.services,
	documents: place.documents,
	typeDocuments: place.typeDocuments,
	owner: `${place.ownerId.name} ${place.ownerId.lastName}`,
	ownerEmail: place.ownerId.email,
	ownerId: place.ownerId._id,
	geofence: place.geofence,
	timeConfiguration: place.timeConfiguration,
	lodgings: place.lodgings,
	address: place.address,
	email: place.email,
	direction: place.direction,
	nombreCliente: place.nombreCliente,
	rutCliente: place.rutCliente,
	nombreSolicitante: place.nombreSolicitante,
	rutSolicitante: place.rutSolicitante,
	telefonoGeneral: place.telefonoGeneral,
	city: place.city,
	temporalOTs: place.temporalOTs,
});

export default formatPlace;
